import { BaseNumberQuestionNode } from './BaseNumberQuestionNode'

export class AmountQuestionNode extends BaseNumberQuestionNode {}
